// src/pages/BulkUploadPage.jsx
import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import Header from "../components/common/Header";
import http from "../api/server";
import { UPLOAD_EXCEL_API } from "../api/apiPath";
import uploadCloud from "../assets/img/upload.png";
const PREVIEW_ROUTE = "/client/:clientName/bulk-preview";

export default function BulkUploadPage() {
  const { userObj } = useSelector((s) => s.user);
  const navigate = useNavigate();
  const { clientName } = useParams();

  const [file, setFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const pickFile = () => inputRef.current?.click();

  const acceptFile = (f) => {
    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".xlsx")) {
      setFile(null);
      setError("Only .xlsx files are allowed.");
      return;
    }
    setError("");
    setFile(f);
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragOver(false);
    acceptFile(e.dataTransfer.files?.[0]);
  };

  const onBrowse = (e) => acceptFile(e.target.files?.[0]);

  const onUpload = async () => {
    if (!file) return;
    setBusy(true);
    setError("");

    try {
      const fd = new FormData();
      // fd.append("file", file);
      fd.append("file", file, file.name);

      const { data } = await http.post(`${UPLOAD_EXCEL_API}?isSave=false`, fd, {
        // ensure no JSON content-type from defaults/interceptors
        transformRequest: [
          (d, headers) => {
            delete headers["Content-Type"];
            if (headers.common) delete headers.common["Content-Type"];
            if (headers.post) delete headers.post["Content-Type"];
            return d; // keep the original FormData
          },
        ],
      });

      //navigate(PREVIEW_ROUTE, { state: { preview: data, file } });
      navigate(generatePath(PREVIEW_ROUTE, { clientName }), {
        state: { preview: data, file },
      });
    } catch (e) {
      //setError(e?.message || "Upload failed.");
      const msg = e?.response?.data?.message || e?.message || "Upload failed.";
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {/* Mobile-only tweaks */}
      <style>{`
  /* force the action row to be a flex row and right-aligned */
  .bu-actions { display: flex !important; justify-content: flex-end !important; }

  @media (max-width: 576px) {
    .bu-card { padding: 16px !important; }
    .bu-drop { min-height: 280px !important; }
    .bu-drop-inner { padding: 22px !important; }
    .bu-actions { justify-content: flex-end !important; padding-right: 6px !important; }
  }
`}</style>

      <Header />

      {userObj && (
        <div
          className="dashboard_body_main"
          style={{ background: "#F5F7FA", minHeight: "100vh" }}
        >
          <div className="d-flex flex-column py-4 px-5 w-100">
            <h2
              className="mb-1"
              style={{ color: "#0F1A2A", fontWeight: 700, textAlign: "left" }}
            >
              Upload File
            </h2>
            <div className="text-muted mb-3" style={{ textAlign: "left" }}>
              Import bulk data using the excel template.
            </div>

            {/* Outer card */}
            <section
              className="p-4 bu-card"
              style={{
                background: "#FFFFFF",
                borderRadius: 12,
                boxShadow: "0 1px 3px rgba(16,24,40,.06)",
              }}
            >
              {/* Dotted drop zone */}
              <div
                className="w-100 bu-drop"
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={onDrop}
                onClick={pickFile}
                role="button"
                tabIndex={0}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") && pickFile()
                }
                style={{
                  border: `2px dashed ${dragOver ? "#F06543" : "#D7DCE1"}`,
                  borderRadius: 12,
                  background: dragOver ? "#FFF5F1" : "#FFF",
                  minHeight: 320,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Everything stays INSIDE the dotted box */}
                <div
                  className="bu-drop-inner text-center"
                  style={{
                    width: "100%",
                    maxWidth: 520,
                    padding: 28,
                  }}
                >
                
                  <img
  src={uploadCloud}
  alt="Upload"
  style={{
    width: 64,
    height: 64,
    marginBottom: 12,
    objectFit: "contain",
    opacity: 0.9,
  }}
/>


                  <div className="mt-2" style={{ color: "#293042" }}>
                    <strong>Drag &amp; drop your files here</strong> or{" "}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        pickFile();
                      }}
                      style={{ color: "#212121", textDecoration: "underline" ,fontWeight:"500"}}
                    >
                      click to browse
                    </span>
                  </div>

                  <small className="text-muted mt-1 d-block">
                    .xlsx only, up to 50MB
                  </small>

                  {file && (
                    <div
                      className="mt-3 small"
                      style={{
                        overflowWrap: "anywhere",
                        wordBreak: "break-word",
                      }}
                    >
                      Selected: <strong>{file.name}</strong>{" "}
                      <span className="text-muted">
                        ({(file.size / (1024 * 1024)).toFixed(2)} MB)
                      </span>
                    </div>
                  )}

                  {error && (
                    <div className="text-danger mt-2 small">{error}</div>
                  )}

                  <input
                    ref={inputRef}
                    type="file"
                    accept=".xlsx"
                    className="d-none"
                    onChange={onBrowse}
                  />
                </div>
              </div>

              <div className="d-flex w-100 mt-3">
                <div className="ms-auto d-flex gap-2 pe-1 bu-actions">
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                    disabled={busy}
                    style={{ minWidth: 120, borderRadius: 8 }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={onUpload}
                    disabled={!file || busy}
                    style={{ minWidth: 120, borderRadius: 8 }}
                  >
                    {busy ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Uploading…
                      </>
                    ) : (
                      "Upload"
                    )}
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
}

// function CloudUploadIcon() {
//   return (
//     <svg
//       width="64"
//       height="64"
//       viewBox="0 0 64 64"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       style={{ display: "block", margin: "0 auto 10px" }}
//     >
//       <path
//         d="M46 28c-.9-6-6.1-10.5-12.3-10.5S22.3 22 21.4 28C16.8 28.4 13 32.4 13 37.1c0 5 4.1 9.1 9.1 9.1h21.8c5 0 9.1-4.1 9.1-9.1 0-4.6-3.4-8.5-8-9"
//         stroke="#F06543"
//         strokeWidth="2.5"
//         strokeLinecap="round"
//       />
//       <path
//         d="M32 40V26"
//         stroke="#F06543"
//         strokeWidth="2.5"
//         strokeLinecap="round"
//       />
//       <path
//         d="M26 32l6-6 6 6"
//         stroke="#F06543"
//         strokeWidth="2.5"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   );
// }
